import React from 'react';

import UiList from '../../../modules/ui/ui-list/ui-list';

import './assets-details-info-body.scss';

interface AssetsDetailsInfoBodyProps {
  from: {
    name: string;
    inn: string;
  };
  to: {
    name: string;
    inn: string;
  };
  fromName?: string;
  toName?: string;
}

enum InfoLabelsStrings {
  FROM = 'Кредитор:',
  TO = 'Покупатель:',
}

const AssetsDetailsInfoBody: React.FC<AssetsDetailsInfoBodyProps> = ({
  from,
  to,
  fromName,
  toName,
}) => (
  <div className="assets-details__info-body">
    <div className="assets-details__list-item">
      <UiList
        className="assets-details__info-list"
        list={[
          { label: fromName ?? InfoLabelsStrings.FROM, value: from.name },
          { label: 'ИНН:', value: from.inn },
        ]}
      />
    </div>
    <div className="assets-details__list-item">
      <UiList
        className="assets-details__info-list"
        list={[
          { label: toName ?? InfoLabelsStrings.TO, value: to.name },
          { label: 'ИНН:', value: to.inn },
        ]}
      />
    </div>
  </div>
);

export default AssetsDetailsInfoBody;
